import { CxEvent } from '@spartacus/core';
import { Params } from '@angular/router';
import { NavigationEvent } from '@spartacus/storefront';

export enum USER_NAVIGATION_LOGIN_STATUS {
  LOGIN = "1",
  NO_LOGIN = "0"
}

export enum USER_NAVIGATION_ENVIRONMENT {
  PRODUCTION = "1",
  PRE_PRODUCTION = "0",
}


export enum USER_NAVIGATION_CLIENT_TYPE {
  EMPRESA = "1",
  PARTICULAR = "0",
}

/**
 * Indicates that a user navigated to an arbitrary page.
 */
export class CustomNavigationEvent extends NavigationEvent {

  /**
   * GTM Structure
   */
  event: string;
}

/**
 * Collects information about the user and the user's navigation.
 */
export class GeneralUserNavigatorEvent extends CxEvent {
  login_status: USER_NAVIGATION_LOGIN_STATUS;
  user_id: string;
  client_type: USER_NAVIGATION_CLIENT_TYPE;
  client_id: string;
  content_group: string;
  content_detail: string;
  environment: USER_NAVIGATION_ENVIRONMENT;
}

